// extracted by mini-css-extract-plugin
export default {"root":"ValidationTextInput_root__mf+Tv","errorMessage":"ValidationTextInput_errorMessage__Bx6SL"};